import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { CreateTagRequest, Tag } from '@ps/feature-tags';
import { TagsApi } from '../api/tags.api';

@Injectable({ providedIn: 'root' })
export class TagsService {
  private readonly _api = inject(TagsApi);

  public getTags(): Observable<Tag[]> {
    return this._api
      .getTags()
      .pipe(map((tags) => tags.filter((tag) => tag.status === 'active')));
  }

  public createTag(request: CreateTagRequest): Observable<Tag> {
    return this._api.createTag(request);
  }
}
